import gql from 'graphql-tag';

export const acknowledgeDOP = gql`
  mutation acknowledgeDOP($input: AcknowledgeDOP) {
    acknowledgeDOP(input: $input) {
      id
      dopGroupId
      contactId
      shiftDate
      createdAt
      dopState
    }
  }
`;
